<template>
  <div v-if="paymentDetails">
    <vs-popup class="extended-popup" title="" :active.sync="viewPaymentDetailsPopupActive">
      <div class="inner-indented-section mx-auto">
        <div class="vx-row flex-wrap title-bar">
          <h3>{{ paymentDetails['rebates_summary_data']['period'][0].split('_').join(' ') }} Rebates</h3>

          <div class="flex-wrap client-specific ml-auto">
            <vs-chip transparent color="dark" class="status-chip custom-bg px-8">
              {{ this.toTitleCase(paymentDetails['status']) }}
            </vs-chip>

            <img class="partner-logo" src="../../assets/images/partner-logos/GoDaddy-Black.png" alt="" />
          </div>
        </div>

        <hr>

        <div class="vx-row flex-wrap mt-10">
          <div class="vx-col w-1/4"><strong>Period</strong></div>
          <div class="vx-col w-1/4"><strong>Payment Mode</strong></div>
          <div class="vx-col w-1/4"><strong>Domain Count</strong></div>
          <div class="vx-col w-1/4"><strong>Rebate Amount</strong></div>
        </div>

        <div class="vx-row flex-wrap">
          <div class="vx-col w-1/4">{{ this.toTitleCase(paymentDetails['rebates_summary_data']['period'][0].split('_').join(' ')) }}</div>
          <div class="vx-col w-1/4">{{ this.toTitleCase(paymentDetails['rebates_summary_data']['payment_mode']) }}</div>
          <div class="vx-col w-1/4">{{ paymentDetails['rebates_summary_data']['domain_count'] }}</div>
          <div class="vx-col w-1/4">${{ paymentDetails['rebates_summary_data']['sum_of_rebates'] }}</div>
        </div>

        <hr>

        <div class="flex mt-10">
          <div class="vx-col w-2/3 mb-2">
            <div class="vx-row">
              <div class="vx-col w-3/4">
                <label class="vs-input--label inline-flex pb-2">{{ labels['calculationSheetLabel'] }}</label>
                <div class="upload-input relative">
                  <vs-button class="upload-btn flex align-center" style="text-overflow: ellipsis" type="filled" icon-pack="feather" icon="icon-file-text" @click="download('rebateCalculationSheet')">{{ paymentDetails['rebates_summary_data']['file_url'].split('/')[paymentDetails['rebates_summary_data']['file_url'].split('/').length - 1] }}</vs-button>
                  <span style=" position: absolute; right: 0%; bottom: 0; transform: translate(-80%, -10%);">
                    <feather-icon icon="DownloadIcon" color="primary" class="primary" style="width: 15px; height: 15px; color: #000000"/>
                  </span>
                </div>
              </div>
            </div>

            <div class="vx-row mt-2">
              <div class="vx-col w-3/4 flex justify-between">
                <div class="w-full mr-2">
                  <label class="vs-input--label inline-flex pb-2 mt-4">{{ labels['clientInvoiceLabel'] }}</label>
                  <div class="upload-input relative">
                    <vs-button class="upload-btn flex align-center" style="text-overflow: ellipsis" type="filled" icon-pack="feather" icon="icon-file-text" @click="download('invoice')">{{ paymentDetails['rebates_status'][0]['invoice_file_name'] }}</vs-button>
                    <span style="position: absolute;right: 0%; bottom: 0;transform: translate(-80%, -10%);">
                      <feather-icon icon="DownloadIcon" color="primary" class="primary" style="width: 15px; height: 15px; color: #000000"/>
                    </span>
                  </div>
                </div>

                <div class="w-full ml-2">
                  <label class="vs-input--label inline-flex pb-2 mt-4">{{ labels['creditNoteLabel'] }}</label>
                  <div class="upload-input relative">
                    <vs-button class="upload-btn flex align-center" type="filled" icon-pack="feather" icon="icon-file-text" @click="download('creditNote')">{{ paymentDetails['rebates_status'][0]['credit_note_file_name'] }}</vs-button>
                    <span style="position: absolute;right: 0%; bottom: 0;transform: translate(-80%, -10%);">
                      <feather-icon icon="DownloadIcon" color="primary" class="primary" style="width: 15px; height: 15px; color: #000000"/>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="vx-col w-1/3 mb-2">
            <label v-if="showCalculationActions" class="vs-input--label inline-flex pb-2">Rebate Calculation Actions:</label>
            <div v-if="showCalculationActions" class="flex flex-wrap" style="justify-content: flex-start; margin-top: 0.5rem">
              <div v-if="paymentDetails['rebates_summary_data']['file_url'] && paymentDetails['rebates_summary_data']['file_url'] !== ''" style="margin-right: 1rem">
                <vs-button icon-pack="feather" icon="icon-check" id="button-with-loading" color="primary" type="filled" class="custom-btn accepted-btn">
                  Accepted
                </vs-button>
              </div>
              <div v-else>
                <vs-button icon-pack="feather" icon="icon-x" id="button-with-loading" color="danger" type="filled" class="custom-btn rejected-btn">
                  Rejected
                </vs-button>
              </div>
            </div>

            <label v-if="showInvoiceActions" class="vs-input--label inline-flex pb-2" style="margin-top: 1rem">Client Invoice Actions:</label>
            <div v-if="showInvoiceActions" class="flex flex-wrap" style="justify-content: flex-start; margin-top: 0.5rem">
              <div v-if="paymentDetails['rebates_status'][0]['invoice_file_name'] && paymentDetails['rebates_status'][0]['invoice_file_name'] !== ''" style="margin-right: 1rem">
                <vs-button icon-pack="feather" icon="icon-check" id="button-with-loading" color="primary" type="filled" class="custom-btn accepted-btn">
                  Accepted
                </vs-button>
              </div>
              <div v-else>
                <vs-button icon-pack="feather" icon="icon-x" id="button-with-loading" color="danger" type="filled" class="custom-btn rejected-btn">
                  Rejected
                </vs-button>
              </div>
            </div>
          </div>
        </div>

        <hr>
      </div>

      <!-- Rebates Summary component START -->
      <RebatesSummarySheet :rebatesSummaryData="rebatesSummaryData" :source="'clientPaymentDetails'"></RebatesSummarySheet>
      <!-- Rebates Summary component END -->
    </vs-popup>
  </div>
</template>

<script>
import RebatesSummarySheet from "@/components/ag-grid-tables/rebates/rebates-summary/RebatesSummarySheet.vue";

export default {
  name: 'ViewPaymentDetails',
  components: {
    RebatesSummarySheet
  },
  data() {
    return {
      viewPaymentDetailsPopupActive: false,
      paymentDetails: null,
      labels: {
        calculationSheetLabel: 'Download Rebate Calculation Sheet(s)',
        clientInvoiceLabel: 'Download Invoice',
        creditNoteLabel: 'Download Credit Note',
      },
      showCalculationActions: true,
      showInvoiceActions: true,
      rebatesSummaryData: []
    }
  },
  mounted() {
    this.$root.$on('clientViewPaymentDetails', (data) => {
      this.paymentDetails = data;
      this.rebatesSummaryData = data.rebates_summary_detail;
      this.paymentDetails['rebateCalculationSheet'] = 'Reg.ru_June22.zip'
      this.paymentDetails['invoice'] = 'Invoice_June22.pdf'
      this.paymentDetails['creditNote'] = 'CreditNote_June2.pdf' 
      this.viewPaymentDetailsPopupActive = true;
    })
  },
  methods: {
    download(assetName) {

    }
  },
  destroyed() {
    this.$root.$off('clientViewPaymentDetails');
  }
}
</script>

<style scoped>

</style>